/**
 * 摇一摇对应事件
 * 调用方式maple.shake
 * 参数使用方式1：
 * 		参数中的第一个函数[startFn]     => 摇动时要执行的函数
 * 		参数中的第二个函数[endFn]       => 摇动结束执行的函数
 * 		参数中的数字类型[interval]      => 连续两次触发事件的时间间隔，默认没有延时
 * 		参数中的布尔类型[continueEvent] => 连续摇动时是否连续触发事件，默认true
 * 	EXP:摇动时每2秒在的控制台打印一下，停止摇动时打印一下
 * 	maple.shake(function(){
 * 		console.log('begin')
 * 	},function(){
 * 		console.log('end')
 * 	},2000)
 * 参数使用方式2：
 * 		传入一个对象，对应结构如下
 * 		{
 * 			startFn=>function
 *		  	endFn=>function
 *		   	interval=>number
 *		    continueEvent=>boolean
 * 		}
 * 参数使用方式3：前两种方式混合使用，对象的优先级更高，会覆盖前面的参数
 * EXP：maple.shake(function(){console.log('begin')},{interval:2000})
 */
var shakeEventList=[];
var bindEvent=_.once(function(){
	var eventName=(function(){
		if('DeviceMotionEvent' in window){
			return 'devicemotion'
		}else if('DeviceOrientationEvent' in window){
			return 'deviceorientation'
		}else{
			return false;
		}
	})()
	if(eventName){
		window.addEventListener(eventName,(e)=>{
		    let acceleration = e.acceleration||e.accelerationIncludingGravity, x, y, z;
		    if(acceleration){
		    	x=acceleration.x;
		    	y=acceleration.y;
		    	z=acceleration.z;
			    if([x,y,z].some(item=>Math.abs(item)>15)){
			    	shakeEventList.forEach(item=>{
		    			clearTimeout(item.timer);
		    			if(item.continueEvent){
		    				item.startFn();
		    			}else if(item.hasRun===false){
	    					item.startFn();
	    					item.hasRun=true;
		    			}
		    			item.timer=setTimeout(function(){
								item.endFn();
								if(!item.continueEvent){
									item.hasRun=false;
								}
		    			}, 500);
			    	})
			    }
		    }
		},false)
	}
})
export default function shake(){
	bindEvent()
	var options={
		startFn:_(arguments).filter(_.isFunction).get(0,new Function),
		endFn:_(arguments).filter(_.isFunction).get(1,new Function),
		interval:_(arguments).filter(_.isNumber).get(0,0),//每次触发startFn的时间间隔
		continueEvent:_(arguments).filter(_.isBoolean).get(0,true)//摇动过程中是否持续执行startFn事件
	}
	_.assign(options,_(arguments).find(_.isPlainObject))
	if(!options.continueEvent){
		options.hasRun=false;
	}else if(options.interval>16){//针对16毫秒的时差做兼容
		options.startFn=_.throttle(options.startFn,options.interval,{ 'trailing': false });
	}
	shakeEventList.push(options)
}
